// src/utils/docstoreTabs.js
export const DOCSTORE_TABS = {
  "P & ID": "1000201",
  "Engineering Drawings": "1000202",
  LAD: "1000203",
  MEB: "1000204",
  "Master List": "1000205",
  Reports: "1000206",
  "User Files": "1000207"
};

export const DocstoreType = {
  "Engineering Drawings": "ENGINEERING_DRAWINGS",
  LAD: "LAD",
  MEB: "MEB",
  Reports: "REPORTS",
  "P & ID": "PNID",
  "User Files" : "USER_FILES"
};

export const DocStorePermissions = [
  "VIEW",
  "RENAME",
  "COPY",
  "MOVE",
  "DELETE",
  "CREATE_FOLDER",
  "UPLOAD_FILE",
  "DOWNLOAD_FILE",
  // "SHARE_FILE",
];

export const DOCSTORE_PERMISSIONS = [
  { key: "VIEW", label: "View Files" },
  { key: "RENAME", label: "Rename" },
  { key: "COPY", label: "Copy" },
  { key: "MOVE", label: "Move" },
  { key: "DELETE", label: "Delete" },
  { key: "CREATE_FOLDER", label: "Create Folder" },
  { key: "UPLOAD_FILE", label: "Upload File" },
  { key: "DOWNLOAD_FILE", label: "Download" },
  // { key: "SHARE_FILE", label: "Share File" },
];
